export enum PageTypeKeys {
  FETCH_PAGE_BREAKPOINT_SUCCESS = 'FETCH_PAGE_BREAKPOINT_SUCCESS',
  SET_PLANOLY_LITE_SUCCESS = 'SET_PLANOLY_LITE_SUCCESS'
}

export interface FetchPageBreakpointSuccessAction {
  type: PageTypeKeys.FETCH_PAGE_BREAKPOINT_SUCCESS;
  breakpoint: string;
}

export interface SetPlanolyLiteSuccess {
  type: PageTypeKeys.SET_PLANOLY_LITE_SUCCESS;
  isPlanolyLite: boolean;
}

export type PageActions = FetchPageBreakpointSuccessAction | SetPlanolyLiteSuccess;

/**
 * Method to get current breakpoint
 * @returns
 */
export const fetchBreakpoint = () => async (dispatch) => {
  let breakpoint = 'desktop';
  const responsiveObserver: any = document.querySelector('pg-responsive-observer');

  if (responsiveObserver && typeof responsiveObserver?.getCurrentViewportSize === 'function') {
    breakpoint = await responsiveObserver.getCurrentViewportSize();
  }

  dispatch({
    type: PageTypeKeys.FETCH_PAGE_BREAKPOINT_SUCCESS,
    breakpoint
  });
};

/**
 * Method to set updated breakpoint
 * @returns
 */
export const setBreakpoint = (breakpoint: 'mobile' | 'tablet' | 'desktop') => async (dispatch) => {
  dispatch({
    type: PageTypeKeys.FETCH_PAGE_BREAKPOINT_SUCCESS,
    breakpoint
  });
};

/**
 * Method to set updated status of planoly lite
 * @returns
 */
export const setPlanolyLite = (queryStringParams: string) => async (dispatch) => {
  const params = new URLSearchParams(queryStringParams);
  const isPlanolyLite = params.has('isPlanolyLite') || (params.has('hmac') && params.has('uid') && params.has('timestamp'));
  dispatch({
    type: PageTypeKeys.SET_PLANOLY_LITE_SUCCESS,
    isPlanolyLite
  });
};
